import React from 'react';
import {
	Grid
} from '@material-ui/core';
import {Breadcrumbs} from "../../../components/Breadcrumbs";
import {useTranslation} from "react-i18next";
import {RefreshButton} from "../../../components/RefreshButton";
import {TriggerVerificationButton} from "./TriggerVerificationButton";
import useAlert from "../../../hooks/useAlert";
import JobsService from "../../../services/JobsService";

const Header = ({onRefresh}) => {
    const { t }  = useTranslation();

	const currentPath = [
        { 'name' : t('Verification status'), 'url' : '/app/verification-status'}
    ];

    const {showSuccess, showError} = useAlert();

	const handleTriggerVerification = async () => {
	    const service = new JobsService();

	    try {
            await service.startDailyVerification();
            showSuccess(t('Job enqueued'));
        } catch (e) {
            showError(t('Error triggering verification: ' + e));
        }
    }

	return (
		<Grid
			container
			spacing={3}
			justifyContent="space-between"
		>
            <Breadcrumbs path={currentPath} />
            <Grid item>
                <RefreshButton onClick={onRefresh} />
                <TriggerVerificationButton onClick={handleTriggerVerification} />
            </Grid>
		</Grid>
	);
};
export default Header;